import React from 'react';
import { List, Button } from '../components';
import { accountConstants } from '../constants';

const { registrationRoles, roles } = accountConstants;

class RoleForm extends React.Component {
    render () {

        return (
            <form onSubmit={this.props.onComplete}>
                <h4 className="form-title">What Role Are You Signing up As?</h4>
                <List items={registrationRoles} className="role-options">
                    {(item, i) => {
                        const itemLabel = roles[item];
                        const isChecked = roles[item] === this.props.value;
                        return (
                            <span key={i} className="role-option">
                                <input type="radio" name="role" value={roles[item]} checked={isChecked} onChange={this.props.onChange}/> { itemLabel }
                            </span>
                        )
                    }}
                </List>
                <div className="form-footer">
                    <Button type="button" onClick={this.props.onCancel}>Cancel</Button>
                    <Button className="primary" type="submit">Next</Button>
                </div>
            </form>
        )
    }
}



export default RoleForm;



// WEBPACK FOOTER //
// ./web-app/components/role-form.jsx